import { CoreImageView } from '@core/widgets';
import { ConditionalRender } from '@libs/core';
import { TAssetsSvgMapValue } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { getInlineStyles } from '../../utils/styles';
import { TLottieAnimationViewProps } from '../../widgets/Animation/LoadingAnimationView';
import { ButtonPillView } from '../../widgets/Buttons/ButtonPillView';
import { getHref } from '../../widgets/Image/imageUtils';
import floatingLayoutStyles from '../../widgets/layout/css/floatingLayout.module.css';
import horizontalLayoutStyles from '../../widgets/layout/css/horizontalLayout.module.css';
import styles from './commonScreen.module.css';

type TAddProps = {
    hasBorder?: boolean;
    breakWord?: boolean;
};

type TCommonScreenProps = (
    | {
          useIcon: true;
          useSpinner?: false;
          Icon:
              | React.ComponentType<{
                    fill?: string;
                }>
              | React.FC;
      }
    | {
          useIcon: false;
          useSpinner?: false;
          iconName: TAssetsSvgMapValue;
      }
    | {
          useSpinner: true;
          useIcon?: false;
      }
) & {
    useBackground?: boolean;
    headerText?: string;
    secondaryText?: string;
    buttonLabel?: string;
    buttonHandleClick?: () => void;
    mainText?: string;
    uid?: string;
    fill?: string;
} & Pick<TLottieAnimationViewProps, 'animationsColor'>;

export const CommonScreen = (props: TCommonScreenProps & TAddProps) => {
    const {
        useIcon,
        headerText,
        secondaryText,
        mainText,
        hasBorder,
        breakWord,
        buttonLabel,
        buttonHandleClick,
        animationsColor = '',
        useBackground = true,
        useSpinner,
        fill = 'pink_100',
    } = props;
    return (
        <div className={clsx(styles.wrapper, useBackground && styles.background)} data-test={props.uid}>
            <div className={styles.container}>
                <div className={styles.centerContainer}>
                    <div>
                        {useIcon && props.Icon && <props.Icon fill={fill} />}
                        {!useIcon && !useSpinner && props.iconName && (
                            <CoreImageView
                                src={getHref(props.iconName)}
                                styleProps={{
                                    width: 80,
                                    height: 80,
                                    iconColor: `var(--color-${fill})`,
                                }}
                            />
                        )}
                        <ConditionalRender condition={useSpinner}>
                            <div className={styles.loaderTrack} style={getInlineStyles({ variables: { animationsColor: animationsColor } })}>
                                <div className={styles.loaderBar} />
                            </div>
                        </ConditionalRender>
                    </div>
                    {/* Для фиолетового выделения следующая конструкция: <><span>{purpleText}</span>{headerText}</span></>*/}
                    {headerText && <div className={styles.headerText}>{headerText}</div>}
                    {secondaryText && <div className={styles.secondaryText}>{secondaryText}</div>}
                    {/* текст небольшого размера */}
                    {mainText && <span className={clsx(styles.mainText, hasBorder && styles.hasBorder, breakWord && styles.breakWord)}>{mainText}</span>}
                    {buttonLabel && (
                        <div className={clsx(floatingLayoutStyles.floatingLayout, floatingLayoutStyles.bottom)}>
                            <div
                                className={clsx(horizontalLayoutStyles.horizontalLayout, horizontalLayoutStyles.arrangementEnd, styles.buttonCenterContainer)}
                                style={{ justifyContent: 'flex-end' }}
                            >
                                <ButtonPillView
                                    label={buttonLabel}
                                    onClick={() => {
                                        if (buttonHandleClick) {
                                            buttonHandleClick();
                                        } else {
                                            window?.location?.reload?.();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
